import React from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { Overlay } from '@chatscope/chat-ui-kit-react';
const RnR = ({ comingSoon }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  return (
    <Grid
      container
      sx={{
        border: isSm ? 0 : 1,
        backgroundColor: isSm ? '' : '#EEF5FF',
        borderRadius: '10px',
        borderColor: 'divider',
        padding: isSm ? 0 : 1,
        height: 'calc(100vh - 80px)',
        overflow: 'hidden',
      }}
    >
      {comingSoon ? (
        <Box sx={{ backgroundColor: 'white' }}>
          <Overlay />
        </Box>
      ) : (
        <Outlet />
      )}
    </Grid>
  );
};
export default RnR;
